
import { IProductDetailProductJson } from '../../../types/PDP';

import InfoToolTip from '../../../components/InfoToolTip.vue';
import { computed, defineComponent, PropType } from 'vue';
import { ToolTipPositionProp } from 'JS/components/ToolTip.vue';
import { useBreakpoints } from 'JS/composables/breakpoint';

export default defineComponent({
	components: {
		InfoToolTip
	},
	props: {
		product: { type: Object as PropType<IProductDetailProductJson>, required: true },
		tooltipPosition: { type: String as PropType<ToolTipPositionProp> }
	},
	setup(props) {
		const additionalCharge = computed(() => props.product.additionalCharge);
		const { isDesktop } = useBreakpoints();
		const tipPosition = computed(() => props.tooltipPosition ?? !isDesktop.value ? 'bottom' : 'right');

		return {
			additionalCharge,
			isDesktop,
			tipPosition,
		};
	}
});
